import { AttendanceConfirmedRecordRepository } from "@/domain/features/company/v2/repositories/attendance_confirmed_record_repository"
import { getFirebaseFirestoreInfra } from "@/infrastructure/firebase_firestore/client"
import { atom } from "jotai"

import type { AttendanceConfirmedRecord } from "../entities/attendance_confirmed_record/attendance_confirmed_record"

export const attendanceConfirmedRecordAtom = atom<
  AttendanceConfirmedRecord | undefined
>(undefined)

export const editAttendanceMemoAtom = atom(
  null,
  async (
    _,
    set,
    {
      note,
      date,
      userId,
      companyId,
    }: {
      note: string
      date: Date
      userId: string
      companyId: string
    }
  ) => {
    try {
      const firestore = getFirebaseFirestoreInfra()

      await new AttendanceConfirmedRecordRepository(firestore).save({
        params: {
          userId,
          date,
          companyId,
        },
        data: { attendanceMemo: note },
      })

      const updateRecord = await new AttendanceConfirmedRecordRepository(
        firestore
      ).fetch({
        companyId,
        userId,
        date,
      })

      set(attendanceConfirmedRecordAtom, updateRecord)
    } catch (error) {
      console.error("Failed to update memo for attendance record 🚨🚨", error)
    }
  }
)
